import * as Types from '../types-api.generated';

import { UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUsersSearchVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  perPage: Types.Scalars['Int'];
  page: Types.Scalars['Int'];
}>;


export type ApiUsersSearch = { search: { page: number, items: Array<{ name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }> } };



export const ApiUsersSearchDocument = /*#__PURE__*/ `
    query UsersSearch($searchTerm: String!, $perPage: Int!, $page: Int!) {
  search: usersSearchDb(query: $searchTerm, perPage: $perPage, page: $page) {
    items {
      ...UserLightFragment
    }
    page
  }
}
    ${UserLightFragment}`;

export const useUsersSearch = <
      TData = ApiUsersSearch,
      TError = ClientError
    >(
      variables: ApiUsersSearchVariables,
      options?: Omit<UseQueryOptions<ApiUsersSearch, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiUsersSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiUsersSearch, TError, TData>(
      {
    queryKey: ['UsersSearch', variables],
    queryFn: apiFetcher<ApiUsersSearch, ApiUsersSearchVariables>(ApiUsersSearchDocument, variables),
    ...options
  }
    )};

useUsersSearch.getKey = (variables: ApiUsersSearchVariables) => ['UsersSearch', variables];

export const useInfiniteUsersSearch = <
      TData = InfiniteData<ApiUsersSearch>,
      TError = ClientError
    >(
      variables: ApiUsersSearchVariables,
      options: Omit<UseInfiniteQueryOptions<ApiUsersSearch, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiUsersSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiUsersSearch, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UsersSearch.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiUsersSearch, ApiUsersSearchVariables>(ApiUsersSearchDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUsersSearch.getKey = (variables: ApiUsersSearchVariables) => ['UsersSearch.infinite', variables];


useUsersSearch.fetcher = (variables: ApiUsersSearchVariables, options?: RequestInit['headers']) => apiFetcher<ApiUsersSearch, ApiUsersSearchVariables>(ApiUsersSearchDocument, variables, options);
